<template>
	<div class="popup" @mousedown.self="$emit('close')">
		<div class="popup__block">
			<div class="popup__top">
				<div class="popup__title">Поставщик "{{ supplier.companyName }}"</div>
				<div class="popup__close" @click="$emit('close')"></div>

			</div>
			<div class="popup__content">
				<SupplierInfo :supplier="supplier" :is-black-list="true"/>
			</div>
			<hr>
			<div class="popup__btns">
				<button class="btn btn--color" @click="$emit('close'), $emit('openPopup')">Восстановить</button>
			</div>
		</div>
	</div>
</template>

<script>
import SupplierInfo from '@/components/sections/Suppliers/SupplierInfo.vue';

export default {
	name: "BlackListPopup",
	components: {SupplierInfo},
	props: {
		supplier: {
			type: Object,
			default: () => {}
		}
	},

}
</script>


